/**
 * initialize slick carousel for .s-hero-v2 selectors
 */

import jQuery from 'jquery'
import 'slick-carousel'

export default class VehicleFeaturesSlick {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.slider = jQuery('.s-vehicle-features-slick__slick', this.$element)
    this._iniSlick()
  }

  _iniSlick() {
    this.slider.slick({
      lazyLoad: 'ondemand',
      autoplay: false,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      fade: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            fade: false,
          },
        },
      ],
    })
  }
}
